import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { ProductService } from '../../../shared/services/product.service';

@Component({
  selector: 'app-room-nav',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './room-nav.component.html',
  styleUrl: './room-nav.component.scss'
})
export class RoomNavComponent {
  readonly path = inject(ActivatedRoute).snapshot.url;
  readonly roomNav = inject(ProductService).getRoomNav(this.path);
}
